/**
 * Custom Author Bylines
 *
 * Strips the #author- prefix from custom author names displayed via internal tags.
 *
 * Usage: Add an internal tag like "#author-John Smith" to a post.
 * The theme will display "John Smith" as the byline.
 */
(function () {
    'use strict';

    document.querySelectorAll('.custom-author-name').forEach(function (el) {
        var name = el.textContent || '';
        // Remove the #author- prefix (case-insensitive)
        el.textContent = name.replace(/^#author-/i, '');
    });
})();
